// production hardware data
import shipping_options from './shipping.prod'

export default [
    {
        label: 'Bat Attachment',
        description: 'for Quest 2',
        stripe_product_id: 'prod_ISMrY4Bm3TjC4J',
        stripe_price_id: 'price_1LZzfCIDrm6Z6HgYdByLCxJE',
        price: 2500,
        wc_id: 1416,
        category: 'bat_attachment',
        shipping_options,
        max_quantity: 20,
    },
    {
        label: 'Bat Attachment',
        description: 'for Quest 3',
        stripe_product_id: 'prod_OpgnJnrzuWhyuU',
        stripe_price_id: 'price_1O21QLIDrm6Z6HgYlBlHyLyv',
        price: 2500,
        wc_id: 1417,
        category: 'bat_attachment',
        shipping_options,
        max_quantity: 20,
    },
    {
        label: 'Bat Attachment',
        description: 'for Quest 2',
        stripe_product_id: 'prod_ISMrY4Bm3TjC4J',
        stripe_price_id: 'price_1LZzfCIDrm6Z6HgYdByLCxJE',
        price: 0,
        msrp: 2500,
        coupon: 'YQHgfCAv',
        wc_id: 1519,
        category: 'bat_attachment',
        shipping_options,
        max_quantity: 20,
    },
    {
        label: 'Bat Attachment',
        description: 'for Quest 3',
        stripe_product_id: 'prod_OpgnJnrzuWhyuU',
        stripe_price_id: 'price_1O21QLIDrm6Z6HgYlBlHyLyv',
        price: 0,
        msrp: 2500,
        coupon: 'YQHgfCAv',
        wc_id: 1518,
        category: 'bat_attachment',
        shipping_options,
        max_quantity: 20,
    },
    {
        label: 'Short Bat ($99 value)',
        description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3 headsets.',
        stripe_product_id: 'prod_P3DtPBbAvPCUg2',
        stripe_price_id: 'price_1OF7RyIDrm6Z6HgYIUpV0taa',
        price: 0,
        wc_id: 113698,
        category: 'short_bat',
        shipping_options: shipping_options.filter(option => option.id === 'standard'),
        max_quantity: 1,
        available_for: ['standard_yearly', 'pro_yearly'],
    },
    {
        label: 'Short Bat',
        description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3 headsets.',
        stripe_product_id: 'prod_P3DtPBbAvPCUg2',
        stripe_price_id: 'price_1OIgy0IDrm6Z6HgYzRl0406T',
        price: 9900,
        wc_id: 113699,
        category: 'short_bat',
        shipping_options: shipping_options.filter(option => option.id === 'standard'),
        max_quantity: 20,
        available_for: ['standard_monthly'],
    },
    {
        label: 'Short Bat (-30%)',
        description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3 headsets.',
        stripe_product_id: 'prod_P3DtPBbAvPCUg2',
        stripe_price_id: 'price_1P7165IDrm6Z6HgYndhLCOvd',
        price: 6930,
        wc_id: 134941,
        category: 'short_bat',
        shipping_options: shipping_options.filter(option => option.id === 'standard'),
        max_quantity: 1,
        available_for: [],
    },
    // {
    //     label: 'Short Bat $99 (40% off)',
    //     description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3 headsets.',
    //     stripe_product_id: 'prod_P3DtPBbAvPCUg2',
    //     stripe_price_id: 'price_1PblFAIDrm6Z6HgYpLgbP2Im',
    //     price: 6000,
    //     wc_id: 142854,
    //     category: 'short_bat',
    //     shipping_options: shipping_options.filter(option => option.id === 'standard'),
    //     max_quantity: 1,
    //     available_for: [],
    // },
    {
        label: 'Short Bat',
        description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3 headsets.',
        stripe_product_id: 'prod_P3DtPBbAvPCUg2',
        stripe_price_id: 'price_1PbNrNIDrm6Z6HgYwZiFSxDf',
        price: 7400,
        msrp: 9900,
        wc_id: 141800,
        category: 'short_bat',
        shipping_options: shipping_options.filter(option => option.id === 'standard'),
        max_quantity: 1,
        available_for: ['standard_yearly', 'pro_monthly', 'pro_yearly'],
    },
    {
        label: 'Meta Quest 2 Headset',
        description: 'Virtual reality headset',
        stripe_product_id: 'prod_P8RvJihPzDXuRt',
        stripe_price_id: 'price_1P6YbnIDrm6Z6HgYHrfT51tl',
        price: 42900,
        wc_id: 117908,
        category: 'headset',
        shipping_options: shipping_options.filter(option => option.id === 'standard'),
        max_quantity: 1,
        bundle_only: true,
    },
    {
        label: 'Meta Quest 3 Headset',
        description: 'Virtual reality headset',
        stripe_product_id: 'prod_QMnpQ54ZeD209A',
        stripe_price_id: 'price_1PW4EqIDrm6Z6HgYCqxB1zvA',
        price: 72700,
        wc_id: 142264,
        category: 'headset',
        shipping_options: shipping_options.filter(option => option.id === 'standard'),
        max_quantity: 1,
        bundle_only: true,
        available_for: ['standard_yearly'],
    },
    {
        label: 'Meta Quest 3 Headset',
        description: 'Virtual reality headset',
        stripe_product_id: 'prod_QMnpQ54ZeD209A',
        stripe_price_id: 'price_1PW4E6IDrm6Z6HgYcN0GLDal',
        price: 85400,
        wc_id: 142265,
        category: 'headset',
        shipping_options: shipping_options.filter(option => option.id === 'standard'),
        max_quantity: 1,
        bundle_only: true,
        available_for: ['pro_yearly'],
    },
] as Hardware[]
